<div ref="ViewEntityType" class="border-card border-0 px-4 py-1 scroll-container">
  <div class="card-header card-header-primary card-nav-tabs border shadow rounded-lg mt-4">
    <div class="nav-tabs-wrapper">
        <div class="d-flex justify-content-between align-items-center border-0 mt-2">
          <div>
            <p class="mb-1 fw-bold text-white d-flex align-items-center gap-1 fs-6">
              <span class="d-flex align-items-center gap-1">
                 <i class="bi bi-person-lines-fill fs-4 me-2"></i>
                 View And Manage Your Trust
              </span>
            </p>
          </div>
        </div>
    </div> 
  </div>

  <!-- Table Card - Responsive by default -->
    <div class="d-flex justify-content-between justify-content-md-start align-items-center mb-3 ">
      <div class="dropdown text-end d-md-none">
        <span
          class="text-dark fw-bold text-xxs cursor-pointer d-inline-flex align-items-center"
          role="button"
          id="assignAdminDropdown"
          data-bs-toggle="dropdown"
          aria-expanded="false"
        >
          Filter Applications
          <i class="bi bi-caret-down-fill ms-1"></i>
        </span>
        <!-- Dropdown items -->
        <ul class="dropdown-menu dropdown-menu-end mt-1 shadow-sm" aria-labelledby="assignAdminDropdown">
          <li>
            <a class="dropdown-item text-xxs" href="#" @click.prevent="set_status_filter('')">
            </a>
          </li>

          <li v-for="key in DROPDOWN_STATUS_KEYS" :key="key">
            <a class="dropdown-item text-xxs" href="#" @click.prevent="set_status_filter(key)">
              {{ format_status_label(key) }}
            </a>
          </li>
        </ul>
      </div>
    </div>

    <div class="shadow-lg border table-border-color rounded-lg p-3 table-responsive text-xs">
      <table class="table table-hover" id="entity_form_management_table">
        <thead class="custom-header">
          <tr>
            <th class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start ps-3">Application No</th>
            <th class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start ps-3">Entity Name</th>
            <th class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start ps-3">Entity Type Name</th>
            <th class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start ps-3">Date Created</th>
            <th class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start ps-3">Status</th>
            <th class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start ps-3">Action</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="row in table_safe_application_list" :key="row['Application No']">
            <td class="text-xxs text-start">{{ row['Application No'] }}</td>
            <td class="text-xxs text-start">{{ row['Entity Name'] }}</td>
            <td class="text-xxs text-start">{{ row['Entity Type Name'] }}</td>
            <td class="text-xxs text-start">{{ row['Date Created'] }}</td>
            <td class="text-xxs text-start">{{ row['Status'] }}</td>
            <td>
              <button
                class="btn btn-primary-dark btn-sm rounded-small shadow text-dark ms-1 text-xxs"
                @click="view_entity_application_overview(row['Application No'], row['Status'], row._entity_profile_id, row._entity_type_id, row['Entity Name'])"
              >
                View
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  <AICampusFooter />
</div>